
<h1 mat-dialog-title>Scan device</h1>
<form autocomplete="off" [formGroup]="form">
  <div mat-dialog-content>

    <ng-template #dynamicComponent></ng-template>


    <div *ngIf="showDeviceTypeOptionAndButton == true">
      <div>Scanned GUDID is not present in our databse, please select device type from list so we can match scanned device to device that is present in ELSO registry database</div>
      <div class="control-item">
        <label>Device type:</label>
        <br />
        <mat-form-field class="select-form-field" floatLabel="always" appearance="fill">
          <mat-select hideSingleSelectionIndicator name="DeviceType" id="DeviceType" placeholder="Please select" formControlName="DeviceType">
            <mat-option>Please select</mat-option>
            <mat-option *ngFor="let dt of enumService.enumScanDeviceTypes" [value]="dt.value">
              {{dt.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="hard-error" *ngIf="form.controls['DeviceType'].hasError('required')">This field is required!</div>
      </div>
      <button class="form-execute-buttons" type="button" color="primary" mat-raised-button (click)="assignTypeToDevice()" [disabled]="form.invalid || !form.controls['DeviceType'].value">Add device</button>
    </div>
    <!--Device Info-->
    <!--<div class="control-item">
      <label for="Manufacturer">Manufacturers:</label>
      <br />
      <mat-form-field class="select-form-field" floatLabel="always" appearance="fill">
        <mat-select hideSingleSelectionIndicator name="Manufacturer" id="Manufacturer" placeholder="Please select" (selectionChange)="deviceFieldsSelectionChange()" formControlName="ManufacturerId">
          <mat-option>Please select</mat-option>
          <mat-option *ngFor="let manufacturer of enumService.DeviceEnums.enumAllManufacturers" [value]="manufacturer.ManufacturerId">
            {{manufacturer.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="control-item">
      <label for="DeviceName">Device name:</label>
      <br />
      <mat-form-field appearance="outline" class="control-item">
        <input matInput type="text" maxlength="200" id="DeviceName" name="DeviceName" (input)="deviceFieldsSelectionChange()" formControlName="DeviceName" class="mat-input">
      </mat-form-field>
    </div>
    <div class="control-item">
      <label for="Model" [class.required-field]="form.controls['Model'].hasError('required')">Model:</label>
      <br />
      <mat-form-field appearance="outline" class="control-item">
        <input matInput type="text" maxlength="20" id="Model" name="Model" formControlName="Model" class="mat-input">
      </mat-form-field>
      <div class="hard-error" *ngIf="form.controls['Model'].hasError('required')">This field is required!</div>
    </div>-->

    <!--<div class="control-item" *ngIf="scanOptionSelected == 1 && scannedDeviceGroups.length > 0">
      <label class="required-field">Pre scanned devices:</label>
      <br />
      <mat-form-field class="select-form-field" floatLabel="always" appearance="fill">
        <mat-select hideSingleSelectionIndicator name="PreScannedDevice" id="PreScannedDevice" placeholder="Please select" formControlName="PreScannedDevice">
          <mat-option>Please select</mat-option>
          <mat-option *ngFor="let o of scannedDeviceGroups" [value]="o.DeviceGudidId">
            {{o.DeviceGudidId}} - {{o.DeviceScanSetName}} - ({{appService.getEnumName(o.DeviceType, enumService.enumScanDeviceTypes)}})
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button class="form-execute-buttons" type="button" color="primary" mat-raised-button (click)="addPreScannedDevice()" [disabled]="form.controls['PreScannedDevice'].value == null">Add device</button>
    </div>-->
    <!--//////////////////////////////////////-->


    <div class="elso-grid" *ngIf="scannedDevices.length > 0">
      <div>Scanned devices:</div>
      <br />
      <div class="elso-grid-row" *ngFor="let scannedDevice of scannedDevices">
        <div style="width: 100%;">
          <a (click)="deleteScannedDevice(scannedDevice)">
            <mat-icon class="mat-icon" matTooltip="Delete" matTooltipPosition="above" color="primary">delete</mat-icon>
          </a>
        </div>
        <div style="width: 100%;">
          <span class="elso-grid-label" style="text-wrap: balance;">Device GUDID id: {{scannedDevice.DeviceGudidId}}</span>
        </div>
        <div class="control-item">
          <span class="elso-grid-label">Device type: {{appService.getEnumName(scannedDevice.DeviceType, enumService.enumScanDeviceTypes)}}</span>
        </div>
      </div>
    </div>
    <br />

    <div mat-dialog-actions>
      <button class="form-execute-buttons" type="button" color="primary" mat-raised-button (click)="confirmDialogOption('yes')" [disabled]="form.invalid || scannedDevices.length == 0">Save</button>
      <button class="form-execute-buttons" type="button" color="primary" mat-raised-button (click)="confirmDialogOption('cancel')">Cancel</button>
    </div>


  </div>
</form>

